// src/config/flavor.js
//
// Flavor-aware configuration.
//
// Four flavors now build from this codebase (SPEC-2026-07-22-demo-checkout.md §7):
//
//   - REACT_APP_FLAVOR=prod         → my.waka.surf              (registration app)
//   - REACT_APP_FLAVOR=preview      → waka-my-preview.web.app   (registration app, forked collections)
//   - REACT_APP_FLAVOR=demo         → demo.waka.surf            (demo day check-out app)
//   - REACT_APP_FLAVOR=demo_preview → waka-demo-preview.web.app (demo app, forked collections)
//
// All builds run against the same Firebase project (waka-agent). Preview-style
// flavors write to forked Firestore collections so live data isn't touched.
//
// All collection name references in the app — services, components, Cloud
// Function calls — MUST import from here. No hardcoded collection strings
// elsewhere in the codebase.
//
// Docs: /docs/SPEC-2026-05-20-my-waka-redesign.md §3 (prod/preview)
//       /docs/SPEC-2026-07-22-demo-checkout.md §5 + §7 (demo flavors)

const RAW = process.env.REACT_APP_FLAVOR;

export const FLAVOR =
  RAW === 'preview' ? 'preview' :
  RAW === 'demo' ? 'demo' :
  RAW === 'demo_preview' ? 'demo_preview' :
  'prod';

export const IS_PREVIEW = FLAVOR === 'preview';
export const IS_DEMO = FLAVOR === 'demo' || FLAVOR === 'demo_preview';
export const IS_DEMO_PREVIEW = FLAVOR === 'demo_preview';

const SUFFIX = IS_PREVIEW ? '_preview' : '';

export const COLLECTIONS = {
  registrations: `registrations${SUFFIX}`,
  publicRegistrations: `publicRegistrations${SUFFIX}`,
  transferEvents: `transferEvents${SUFFIX}`,
  adminLogs: `adminLogs${SUFFIX}`,
  // admins/ is shared between flavors — operators are the same.
  admins: 'admins',
  // emailLogs/ is shared — Cloud Function audit log.
  emailLogs: 'emailLogs',
};

// Demo-app collections (SPEC-2026-07-22-demo-checkout.md §5). The demo flavors
// NEVER touch the registration collections above; these are fully isolated.
const DEMO_SUFFIX = IS_DEMO_PREVIEW ? '_demo_preview' : '';

export const DEMO_COLLECTIONS = {
  demoSpots: `demoSpots${DEMO_SUFFIX}`,
  demoFleet: `demoFleet${DEMO_SUFFIX}`,
  demoSessions: `demoSessions${DEMO_SUFFIX}`,
  demoWaivers: `demoWaivers${DEMO_SUFFIX}`,
  // Walk-up lead capture (Nigel 2026-07-23) — people at the tent who don't
  // ride but want the follow-up. Flavored like sessions/waivers.
  demoLeads: `demoLeads${DEMO_SUFFIX}`,
  // Staff + requests are shared between demo flavors (same people run tests),
  // mirroring the admins/ convention.
  demoStaff: 'demoStaff',
  demoStaffRequests: 'demoStaffRequests',
  admins: 'admins',
};

// Convenience for tagging logs / UI banners with which flavor is running.
export const FLAVOR_LABEL =
  IS_PREVIEW ? 'PREVIEW' :
  IS_DEMO_PREVIEW ? 'DEMO PREVIEW' :
  FLAVOR === 'demo' ? 'DEMO' :
  'PROD';
